/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：5
 */

var r
var o
export { r as s }
export { o as q }
export { WIDGET as M }
export { BUTTON_WIDGET as d }
export { NEW_BUTTON_WIDGET as z }
export { INPUT_WIDGET as w }
export { TEXT_WIDGET as H }
export { IMAGE_WIDGET as v }
export { RADIO_WIDGET as C }
export { CHECKBOX_WIDGET as g }
export { WEB_VIEW_WIDGET as L }
export { SWITCH_WIDGET as F }
export { SLIDER_WIDGET as E }
export { LIST_VIEWER_WIDGET as x }
export { NEW_LIST_VIEWER_WIDGET as A }
export { CANVAS_WIDGET as f }
export { BRUSH_WIDGET as c }
export { ACTOR_WIDGET as a }
export { CAMERA_WIDGET as e }
export { AUDIO_WIDGET as b }
export { GYROSCOPE_WIDGET as t }
export { VOLUME_SENSOR_WIDGET as K }
export { DATE_PICKER_WIDGET as n }
export { TIME_PICKER_WIDGET as J }
export { TIMER_WIDGET as I }
export { HTTP_CLIENT_WIDGET as u }
export { CLOUD_ROOM_WIDGET as i }
export { LOCAL_STORAGE_WIDGET as y }
export { NEW_LOCAL_STORAGE_WIDGET as B }
export { CLOUD_STORAGE_WIDGET as l }
export { CLOUD_SPACE_DICT_WIDGET as j }
export { DATABASE_WIDGET as m }
export { CLOUD_DB_WIDGET as h }
export { CLOUD_SPACE_TABLE_WIDGET as k }
export { TABLE_DATA_WIDGET as G }
export { SCREEN as D }
export { U as r }
export { i as p }
export { s as o };
(function (e) {
  e.SMALL = "SMALL"
  e.MEDIUM = "MEDIUM"
  e.LARGE = "LARGE"
})(r || (r = {}));
(function (e) {
  e[e.FIXED = 0] = "FIXED"
  e[e.AUTO_WIDTH = 1] = "AUTO_WIDTH"
  e[e.AUTO_HEIGHT = 2] = "AUTO_HEIGHT"
  e[e.AUTO_ALL = 3] = "AUTO_ALL"
})(o || (o = {}))
var i
var a
var s

export const WIDGET = "WIDGET"
export const BUTTON_WIDGET = "BUTTON_WIDGET"
export const NEW_BUTTON_WIDGET = "NEW_BUTTON_WIDGET"
export const INPUT_WIDGET = "INPUT_WIDGET"
export const TEXT_WIDGET = "TEXT_WIDGET"
export const IMAGE_WIDGET = "IMAGE_WIDGET"
export const RADIO_WIDGET = "RADIO_WIDGET"
export const CHECKBOX_WIDGET = "CHECKBOX_WIDGET"
export const WEB_VIEW_WIDGET = "WEB_VIEW_WIDGET"
export const SWITCH_WIDGET = "SWITCH_WIDGET"
export const SLIDER_WIDGET = "SLIDER_WIDGET"
export const LIST_VIEWER_WIDGET = "LIST_VIEWER_WIDGET"
export const NEW_LIST_VIEWER_WIDGET = "NEW_LIST_VIEWER_WIDGET"
export const CANVAS_WIDGET = "CANVAS_WIDGET"
export const BRUSH_WIDGET = "BRUSH_WIDGET"
export const ACTOR_WIDGET = "ACTOR_WIDGET"
export const CAMERA_WIDGET = "CAMERA_WIDGET"
export const AUDIO_WIDGET = "AUDIO_WIDGET"
export const GYROSCOPE_WIDGET = "GYROSCOPE_WIDGET"
export const VOLUME_SENSOR_WIDGET = "VOLUME_SENSOR_WIDGET"
export const DATE_PICKER_WIDGET = "DATE_PICKER_WIDGET"
export const TIME_PICKER_WIDGET = "TIME_PICKER_WIDGET"
export const TIMER_WIDGET = "TIMER_WIDGET"
export const HTTP_CLIENT_WIDGET = "HTTP_CLIENT_WIDGET"
export const CLOUD_ROOM_WIDGET = "CLOUD_ROOM_WIDGET"
export const LOCAL_STORAGE_WIDGET = "LOCAL_STORAGE_WIDGET"
export const NEW_LOCAL_STORAGE_WIDGET = "NEW_LOCAL_STORAGE_WIDGET"
export const CLOUD_STORAGE_WIDGET = "CLOUD_STORAGE_WIDGET"
export const CLOUD_SPACE_DICT_WIDGET = "CLOUD_SPACE_DICT_WIDGET"
export const DATABASE_WIDGET = "DATABASE_WIDGET"
export const CLOUD_DB_WIDGET = "CLOUD_DB_WIDGET"
export const CLOUD_SPACE_TABLE_WIDGET = "CLOUD_SPACE_TABLE_WIDGET"
export const TABLE_DATA_WIDGET = "TABLE_DATA_WIDGET"
export const SCREEN = "SCREEN"

var U = {
  CREATE: "CREATE"
}
!function (e) {
  e.DEFAULT = "DEFAULT"
  e.PROPORTIONAL = "PROPORTIONAL"
}(i || (i = {}));
(function (e) {
  e.HORIZONTAL = "HORIZONTAL"
  e.VERTICAL = "VERTICAL"
  e.BOTH = "BOTH"
  e.NONE = "NONE"
})(a || (a = {}));
(function (e) {
  e.ONLY_TITLE = "ONLY_TITLE"
  e.TITLE_AND_SUBTITLE = "TITLE_AND_SUBTITLE"
  e.IMAGE_TITLE_AND_SUBTITLE = "IMAGE_TITLE_AND_SUBTITLE"
  e.AVATAR_AND_TITLE_SUBTITLE = "AVATAR_AND_TITLE_SUBTITLE"
  e.IMAGE_AND_TITLE_DESC = "IMAGE_AND_TITLE_DESC"
  e.AVATAR_TITLE_SUBTITLE_AND_IMAGE_DESC = "AVATAR_TITLE_SUBTITLE_AND_IMAGE_DESC"
  e.IMAGE_AND_AVATAR_TITLE_SUBTITLE_AND_DESC = "IMAGE_AND_AVATAR_TITLE_SUBTITLE_AND_DESC"
})(s || (s = {}))
